import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  params: {
    distance: number;
    longitude: string;
    latitude: string;
    postalCode: string;
    providerName: string;
    providerType: string;
    specialty: string;
    scoreHigherThan: number;
    scoreLowerThan: number;
    isContracted: boolean;
    contractStatus: string;
    isFavorite: boolean;
    gender: string;
    fetchCurrentLocation: boolean;
    location: string;
    limit: string;
    currentAttempt: number;
    extendedDistance: number;
    isMore: boolean;
  };
  error: boolean;
  // building: boolean;
} = {
  params: {
    distance: 30,
    longitude: "",
    latitude: "",
    postalCode: "",
    providerName: "",
    providerType: "",
    specialty: "",
    scoreHigherThan: 0,
    scoreLowerThan: 10,
    isContracted: false,
    contractStatus: "",
    isFavorite: false,
    gender: "Gender",
    fetchCurrentLocation: true,
    location: "",
    limit: "",
    currentAttempt: -1,
    extendedDistance: 100,
    isMore: false,
  },
  error: false,
  // building: false,
};

const addSearchParam = (state = initialState, action) => {
  console.log([action.paramName], [action.paramValue]);
  const updatedSearchParam = {
    [action.paramName]: action.paramValue,
  };
  const updatedParams = updateObject(state["params"], updatedSearchParam);
  const updatedState = {
    params: updatedParams,
    // building: true,
  };
  return updateObject(state, updatedState);
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_SEARCH_PARAM:
      return addSearchParam(state, action);
    case actionTypes.RESET_SEARCH_PARAM:
      return initialState;
    default:
      return state;
  }
};
export default reducer;
